import { useCallback } from "react"

import { useQuery } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import Urls from "@/api/urls"
import { ServerStateKeys } from "@/constants"

const getOffboarding = async () => {
    const { data } = await axiosClient.get(Urls.offboardingJourneyReflection())
    return data
}

export default function useOffBoarding() {
    return useQuery({
        queryKey: [ServerStateKeys.Offboarding],
        queryFn: getOffboarding,
        select: useCallback(data => {
            return data
        }, [])
    })
}
